export default "__VITE_ASSET__DGpAfIGa__"